var LogoSetter = require('./logo');
var IconCreator = require('../creators/icon');
var StickerGetter = require('./sticker');

module.exports = IconSetter;

function IconSetter () {
  this.handledAttributes = _.union([
    'shapes',
    'thumb_src',
    'is_vector'
  ], this.handledAttributes);

  this.supportedSubElements = ['image', 'ellipse', 'line', 'rect', 'text', 'polygon', 'circle', 'ellipse', 'path', 'g'];
}

IconSetter.prototype = new LogoSetter();
IconSetter.prototype.constructor = IconSetter;
IconSetter.prototype.updateContent = IconCreator.prototype.updateContent;
IconSetter.prototype.getElementsByColorGroup = StickerGetter.prototype.getElementsByColorGroup;
